import { create } from 'zustand'

export type QualityLevel = 'GOOD' | 'WARNING' | 'POOR' | null

interface SocketStoreState {
  connected: boolean
  recovered: boolean
  quality: QualityLevel
  mos: number | null
  packetLoss: number | null
  setConnected: (connected: boolean, recovered?: boolean) => void
  setQuality: (
    quality: Exclude<QualityLevel, null>,
    mos: number,
    packetLoss: number,
  ) => void
  resetQuality: () => void
}

export const useSocketStore = create<SocketStoreState>()((set) => ({
  connected: false,
  recovered: false,
  quality: null,
  mos: null,
  packetLoss: null,
  setConnected: (connected, recovered = false) => set({ connected, recovered }),
  setQuality: (quality, mos, packetLoss) => set({ quality, mos, packetLoss }),
  resetQuality: () => set({ quality: null, mos: null, packetLoss: null }),
}))
